import * as R from 'ramda';
import { Action } from 'redux';
import { ActionType } from './core/redux/actionType';
import { AppState } from './core/redux/appState';


type ShowTimeoutModalAction = {
  type     : ActionType.ShowTimeoutModalAction;
  showModal: boolean;
}


export const showTimeoutModalAction = (
  show: boolean,
): ShowTimeoutModalAction => ({
  type:      ActionType.ShowTimeoutModalAction,
  showModal: show,
});


export const showTimeoutModalReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ActionType.ShowTimeoutModalAction) {
    return state;
  }

  return R.assoc('showTimeoutModal', (action as ShowTimeoutModalAction).showModal, state);
};
